import { useMemo, useState } from "react";
import { LocalizationText } from "@/app/index";
import { SectionTabs } from "@/components/section-tabs/index";
import { usePageContextHardware } from "../../context/hardware-context";

export const TabPanel = ({
  moduleToInstallList,
  moduleInstalledList,
  moduleCanceledList,
}: {
  moduleToInstallList: React.ReactNode;
  moduleInstalledList: React.ReactNode;
  moduleCanceledList: React.ReactNode;
}) => {
  const [activeKey, setActiveKey] = useState<string>("to-install");
  const {
    controllerDataTableToInstall,
    controllerDataTableInstalled,
    controllerDataTableCanceled,
  } = usePageContextHardware();

  const items = useMemo(
    () => [
      {
        key: "to-install",
        label: <LocalizationText value="hardware.tab.panel.text.to.install" />,
        count: controllerDataTableToInstall.dataSourceTotal,
        children: moduleToInstallList,
      },
      {
        key: "installed",
        label: <LocalizationText value="hardware.tab.panel.text.installed" />,
        count: controllerDataTableInstalled.dataSourceTotal,
        children: moduleInstalledList,
      },
      {
        key: "canceled",
        label: <LocalizationText value="hardware.tab.panel.text.canceled" />,
        count: controllerDataTableCanceled.dataSourceTotal,
        children: moduleCanceledList,
      },
    ],
    [
      controllerDataTableToInstall.dataSourceTotal,
      controllerDataTableInstalled.dataSourceTotal,
      controllerDataTableCanceled.dataSourceTotal,
    ],
  );

  return (
    <SectionTabs items={items} activeKey={activeKey} onChange={setActiveKey} />
  );
};
